import { rest } from "msw";
import { apiUrl } from "features/configure";
import { communityAnalysis } from "./data/MockCommunityAnalysis";
import dappTracking from "./data/MockDappTracking";

const getDappObjectiveList = rest.get(
  `${apiUrl}/api/dAppTracking/:entityName/contracts`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappActivityTracking));
  }
);

const getDappTrackingStats = rest.post(
  `${apiUrl}/api/dAppTracking/:entityName/stats`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.stats));
  }
);

const getDappTrackingWalletActivityOverview = rest.post(
  `${apiUrl}/api/dAppTracking/:entityName/walletActivityOverview`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(dappTracking.dappTracking.walletActivityOverview)
    );
  }
);

const getDappTrackingNewWalletData = rest.post(
  `${apiUrl}/api/dAppTracking/:entityName/newWallets`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.newWallets));
  }
);

const getDappTrackingCohortData = rest.post(
  `${apiUrl}/api/dAppTracking/:entityName/cohortRetentionAnalysis`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.cohort));
  }
);

const getDappObjectiveListSubEntity = rest.get(
  `${apiUrl}/apiEvaluate/dAppTracking/:entityName/:subEntityName/contracts`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappActivityTracking));
  }
);

const getDappTrackingStatsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dAppTracking/:entityName/:subEntityName/stats`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.stats));
  }
);

const getDappTrackingWalletActivityOverviewSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dAppTracking/:entityName/:subEntityName/walletActivityOverview`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(dappTracking.dappTracking.walletActivityOverview)
    );
  }
);

const getDappTrackingNewWalletDataSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dAppTracking/:entityName/:subEntityName/newWallets`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.newWallets));
  }
);

const getDappTrackingCohortDataSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dAppTracking/:entityName/:subEntityName/cohortRetentionAnalysis`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(dappTracking.dappTracking.cohort));
  }
);

export const dappTrackingMocks = [
  getDappObjectiveList,
  getDappTrackingStats,
  getDappTrackingWalletActivityOverview,
  getDappTrackingNewWalletData,
  getDappTrackingCohortData,
  getDappObjectiveListSubEntity,
  getDappTrackingStatsSubEntity,
  getDappTrackingWalletActivityOverviewSubEntity,
  getDappTrackingNewWalletDataSubEntity,
  getDappTrackingCohortDataSubEntity,
];
